// @ts-ignore
import { useSelector } from 'react-redux';
import * as companySelectors from '../selectors/company';

export const getCompanyName = () => useSelector(companySelectors.getCompanyName);
